import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'

import { FormData } from '../../ChallengeAdmin'
import { activityTypes } from '../../activityTypes'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import { ignoreCategoriesForPoints } from './ChallengePoints'
import { YumActivityIcon } from '../../../../components/YumActivityIcon/YumActivityIcon'
import ChallengeActivitySelect from '../ChallengeActivitySelect/ChallengeActivitySelect'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  name: any
  onActivityTypeChange: any
  fields: any[]
  index: number
}

export default function ChallengePointsActivityTypeField(props: ChallengePointsUnitFieldProps) {
  const { control, name, onActivityTypeChange, fields, index } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  const handleChange = (...event: any[]) => {
    onChange(...event)
    onActivityTypeChange(index, ...event)
  }

  const supportsCustomIcon = [
    CustomTypeCategory.CUSTOM_SIMPLE,
    CustomTypeCategory.CUSTOM_WITH_AMOUNT,
    CustomTypeCategory.BONUS_SIMPLE,
    CustomTypeCategory.BONUS_WITH_AMOUNT,
  ].includes(value)
  const showIcon = !supportsCustomIcon

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <ChallengeActivitySelect
          selectedActivity={value}
          onSelect={(value) => handleChange({ target: { value } })}
          fields={fields}
          currentFieldIndex={index}
        />
        /*<YumSelect
          label={t`Activity type`}
          StartIconComponent={
            showIcon ? <YumActivityIcon category={otherField.value} color={'darkBlue'} isInactive={true} /> : null
          }
          /!*sideMargin={41}*!/
          inputRef={ref}
          {...otherField}
          style={{ marginBottom: '12px' }}
          onChange={handleChange}
        >
          <optgroup label={t`Automated sync`}>
            {activityTypes.map(
              (activityType, keyIndex) =>
                /!* @ts-ignore *!/
                !ignoreCategoriesForPoints.includes(activityType.value) &&
                activityType.usesIntegration && (
                  <option
                    key={keyIndex}
                    value={activityType.value}
                    disabled={fields.some((f) => f.category === activityType.value && f.category !== otherField.value)}
                  >
                    {activityType.label}
                  </option>
                ),
            )}
            {/!*<option value={CustomTypeCategory.OTHER_MIN}>{t`Other exercise minutes`}</option>*!/}
          </optgroup>
          <optgroup label={t`Manual entry`}>
            {activityTypes
              .slice()
              .sort((a, b) => a.label.localeCompare(b.label))
              .map(
                (activityType, keyIndex) =>
                  /!* @ts-ignore *!/
                  !ignoreCategoriesForPoints.includes(activityType.value) &&
                  !activityType.usesIntegration && (
                    <option
                      key={keyIndex}
                      value={activityType.value}
                      disabled={fields.some(
                        (f) => f.category === activityType.value && f.category !== otherField.value,
                      )}
                    >
                      {activityType.label}
                    </option>
                  ),
              )}
          </optgroup>
          <optgroup label={t`Custom`}>
            <option value={CustomTypeCategory.CUSTOM_SIMPLE}>
              {t`Custom`} ({t`simple`.toLowerCase()})
            </option>
            <option value={CustomTypeCategory.CUSTOM_WITH_AMOUNT}>
              {t`Custom`} ({t`with amount`.toLowerCase()})
            </option>
          </optgroup>
          <optgroup label={t`Bonus points`}>
            <option value={CustomTypeCategory.BONUS_SIMPLE}>
              {t`Bonus points`} ({t`simple`.toLowerCase()})
            </option>
            <option value={CustomTypeCategory.BONUS_WITH_AMOUNT}>
              {t`Bonus points`} ({t`with amount`.toLowerCase()})
            </option>
          </optgroup>
        </YumSelect>*/
      )}
    />
  )
}
